import React, { useState } from 'react';
import Login from './Login';
import AdminPanel from './AdminPanel';
import VolleyballCalendar from './VolleyballCalendar';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [isAdmin, setIsAdmin] = useState(localStorage.getItem('isAdmin') === 'true');

  const handleLogin = (newToken, adminStatus) => {
    setToken(newToken);
    setIsAdmin(adminStatus);
    localStorage.setItem('token', newToken);
    localStorage.setItem('isAdmin', adminStatus);
  };

  const handleLogout = () => {
    setToken(null);
    setIsAdmin(false);
    localStorage.removeItem('token');
    localStorage.removeItem('isAdmin');
  };

  if (!token) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div>
      <AdminPanel token={token} onLogout={handleLogout} isAdmin={isAdmin} />
      <VolleyballCalendar token={token} onLogout={handleLogout} isAdmin={isAdmin} />
    </div>
  );
}

export default App;
